import { useEffect, useRef, useState } from 'react'
import hipersendService from '../../../services/hipersend'

const INTERVALO_MS = 5000

// Consulta o pulso da instância a cada 5s enquanto o modo ao vivo está ligado.
// Mesmo cuidado do auto-refresh antigo do relatório: não consulta com a aba
// escondida, não empilha chamada sobre chamada e para ao desmontar.
//
// Além do último pulso, guarda os eventos já vistos: o feed "Agora mesmo" só
// anima o que é novo de verdade, e não a lista inteira a cada batida.
export default function usePulso({ api, secret, ativo }) {
  const [pulso, setPulso] = useState(null)
  const [atualizadoEm, setAtualizadoEm] = useState(null)
  const [falhou, setFalhou] = useState(false)
  const emVoo = useRef(false)

  useEffect(() => {
    if (!api || !secret) return undefined
    let vivo = true

    const bater = async () => {
      if (typeof document !== 'undefined' && document.hidden) return
      if (emVoo.current) return
      emVoo.current = true
      try {
        const novo = await hipersendService.notificacoesInteligentes.getPulso(api, secret)
        if (!vivo) return
        setPulso(novo)
        setAtualizadoEm(Date.now())
        setFalhou(false)
      } catch (e) {
        if (vivo) setFalhou(true)
      } finally {
        emVoo.current = false
      }
    }

    // A primeira batida acontece mesmo pausado: o topo nunca abre vazio.
    bater()
    if (!ativo) return () => { vivo = false }

    const id = setInterval(bater, INTERVALO_MS)
    const aoVoltar = () => { if (!document.hidden) bater() }
    document.addEventListener('visibilitychange', aoVoltar)
    return () => {
      vivo = false
      clearInterval(id)
      document.removeEventListener('visibilitychange', aoVoltar)
    }
  }, [api, secret, ativo])

  return { pulso, atualizadoEm, falhou }
}
